<div class="onboarding animate-fade-in">

  <!-- Progress bar -->
  <div class="onboarding__progress">
    <div class="onboarding__progress-fill" [style.width.%]="(stepIndex + 1) / steps.length * 100"></div>
  </div>

  <!-- Step: Welcome -->
  <div class="onboarding__card" *ngIf="step === 'welcome'">
    <div class="onboarding__icon-hero">
      <span class="material-symbols-outlined">waving_hand</span>
    </div>
    <h1>¡Bienvenido, {{ profesionalName }}!</h1>
    <p class="onboarding__subtitle">
      Configurá tu perfil en 3 pasos para empezar a recibir reservas online.
    </p>

    <div class="steps-preview">
      <div class="step-preview">
        <span class="step-preview__num">1</span>
        <div>
          <strong>Tus servicios</strong>
          <p>Definí qué ofrecés y a qué precio.</p>
        </div>
      </div>
      <div class="step-preview">
        <span class="step-preview__num">2</span>
        <div>
          <strong>Tu disponibilidad</strong>
          <p>Configurá tu horario semanal.</p>
        </div>
      </div>
      <div class="step-preview">
        <span class="step-preview__num">3</span>
        <div>
          <strong>Compartir link</strong>
          <p>Enviá tu página de reservas a tus clientes.</p>
        </div>
      </div>
    </div>

    <button class="btn-primary onboarding__cta" (click)="next()">
      <span class="material-symbols-outlined">arrow_forward</span>
      Empezar configuración
    </button>
  </div>

  <!-- Step: Services -->
  <div class="onboarding__card" *ngIf="step === 'services'">
    <div class="onboarding__step-header">
      <span class="onboarding__step-badge">Paso 1 de 3</span>
      <h2>Tus servicios</h2>
      <p class="onboarding__subtitle">Activá los servicios que querés ofrecer y ajustá los precios.</p>
    </div>

    <div class="services-list">
      <div class="service-row" *ngFor="let svc of services">
        <label class="toggle">
          <input type="checkbox" [(ngModel)]="svc.enabled" />
          <span class="toggler"></span>
        </label>
        <div class="service-row__info" [class.service-row__info--disabled]="!svc.enabled">
          <span class="service-row__label">{{ svc.label }}</span>
          <span class="service-row__duration">{{ svc.duration }} min</span>
        </div>
        <div class="service-row__price" *ngIf="svc.enabled">
          <span>$</span>
          <input type="number" class="price-input" [(ngModel)]="svc.price" min="0" step="500" />
        </div>
      </div>
    </div>

    <div class="onboarding__nav">
      <button class="btn-secondary" (click)="back()">
        <span class="material-symbols-outlined">arrow_back</span>
        Volver
      </button>
      <button class="btn-primary" (click)="next()">
        Siguiente
        <span class="material-symbols-outlined">arrow_forward</span>
      </button>
    </div>
  </div>

  <!-- Step: Availability -->
  <div class="onboarding__card" *ngIf="step === 'availability'">
    <div class="onboarding__step-header">
      <span class="onboarding__step-badge">Paso 2 de 3</span>
      <h2>Tu disponibilidad</h2>
      <p class="onboarding__subtitle">Configurá en qué días y horarios aceptás turnos.</p>
    </div>

    <div class="avail-grid">
      <div class="avail-row" *ngFor="let day of days">
        <div class="avail-row__day">
          <label class="toggle">
            <input type="checkbox" [(ngModel)]="daySchedule(day).enabled" />
            <span class="toggler"></span>
          </label>
          <span class="avail-row__name" [class.avail-row__name--disabled]="!daySchedule(day).enabled">
            {{ dayNames[day] }}
          </span>
        </div>
        <div class="avail-row__times" *ngIf="daySchedule(day).enabled">
          <select [(ngModel)]="daySchedule(day).from">
            <option *ngFor="let t of timeOptions" [value]="t">{{ t }}</option>
          </select>
          <span class="avail-row__sep">–</span>
          <select [(ngModel)]="daySchedule(day).to">
            <option *ngFor="let t of timeOptions" [value]="t">{{ t }}</option>
          </select>
        </div>
        <span class="avail-row__off" *ngIf="!daySchedule(day).enabled">No disponible</span>
      </div>
    </div>

    <div class="onboarding__nav">
      <button class="btn-secondary" (click)="back()">
        <span class="material-symbols-outlined">arrow_back</span>
        Volver
      </button>
      <button class="btn-primary" (click)="next()">
        Siguiente
        <span class="material-symbols-outlined">arrow_forward</span>
      </button>
    </div>
  </div>

  <!-- Step: Share -->
  <div class="onboarding__card" *ngIf="step === 'share'">
    <div class="onboarding__step-header">
      <span class="onboarding__step-badge">Paso 3 de 3</span>
      <h2>¡Todo listo!</h2>
      <p class="onboarding__subtitle">Compartí tu link personalizado para que tus clientes puedan reservar.</p>
    </div>

    <div class="share-link-card">
      <span class="material-symbols-outlined share-link-card__icon">link</span>
      <span class="share-link-card__url">{{ publicLink }}</span>
      <button class="icon-btn" (click)="copyLink()" title="Copiar link">
        <span class="material-symbols-outlined">content_copy</span>
      </button>
    </div>

    <div class="share-hints">
      <div class="share-hint">
        <span class="material-symbols-outlined">share</span>
        <span>Compartilo en redes sociales o WhatsApp</span>
      </div>
      <div class="share-hint">
        <span class="material-symbols-outlined">email</span>
        <span>Pegalo en tu firma de email</span>
      </div>
      <div class="share-hint">
        <span class="material-symbols-outlined">qr_code</span>
        <span>Generá un QR para tu local (próximamente)</span>
      </div>
    </div>

    <div class="onboarding__nav">
      <button class="btn-secondary" (click)="back()">
        <span class="material-symbols-outlined">arrow_back</span>
        Volver
      </button>
      <button class="btn-primary onboarding__finish" (click)="saveAndFinish()">
        <span class="material-symbols-outlined">check_circle</span>
        Terminar y ver panel
      </button>
    </div>
  </div>

</div>
